import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';
import { CustomScroll } from 'react-custom-scroll';
import { useSelector } from 'react-redux';
import {
    selectNodeProjectSelected,
    selectProjectSelected,
} from '../../../store/project/project.selector';
import AttachmentsTreeView from '../../attachments-tree-view/attachments-tree-view.components';
import {
    CustomSideBar,
    CustomSideBarSubTitle,
    CustomSideBarTitle,
} from './side-bar.styles';

const SideBar = () => {
    const projectSelected = useSelector(selectProjectSelected);
    const nodeProjectSelected = useSelector(selectNodeProjectSelected);

    const currentProject = projectSelected ?? nodeProjectSelected;

    return (
        <CustomSideBar>
            <CustomSideBarTitle>DOCUMENTAZIONE</CustomSideBarTitle>
            <Box height={10} />
            {currentProject ? (
                <Fragment>
                    <CustomSideBarSubTitle>
                        PROGETTO {currentProject.name}
                    </CustomSideBarSubTitle>
                    <Box height={28} />
                    <CustomScroll
                        heightRelativeToParent="100%"
                        className="custom-scroll"
                    >
                        <AttachmentsTreeView items={currentProject.content} />
                    </CustomScroll>
                </Fragment>
            ) : (
                <Typography textAlign={'center'}>
                    Nessun Progetto Selezionato
                </Typography>
            )}
        </CustomSideBar>
    );
};

export default SideBar;
